export default "__VITE_ASSET__Dxw5kolT__"